// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import BoomStepSeparatorSvgAsComponent from '../../assets/svg/asComponent/BoomStepSeparatorSvgAsComponent';
import BoomUIBySkinId from '../../constants/ui';
import { useBoomContext } from '../../contexts/BoomContext';
import { useBoomHomeContext } from '../../contexts/BoomHomeContext';
import { type BoomStepState } from '../../reducers/boom';
import { type BoomStepStatus } from '../../types/steps';
import BoomStepDetailsInfoContainer from '../BoomStepDetailsInfo/BoomStepDetailsInfoContainer';
import BoomStepItemContainer from '../BoomStepItem/BoomStepItemContainer';
import BoomBoxWrapper from '../common/BoomBoxWrapper';

const StyledBoomBoxWrapper = styled(BoomBoxWrapper)`
  padding: 1em;
`;

const StepList = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 0 0.3em;
`;

const SeparatorWrapper = styled.div`
  height: 2.5em;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSeparator = styled(BoomStepSeparatorSvgAsComponent)`
  width: 0.7em;
`;

const StyledBoomDetailsInfoContainer = styled(BoomStepDetailsInfoContainer)`
  background-color: transparent;
  border: none;
  margin: 0 0 0.9em 0;
  padding: 0;
`;

const CongratulationsWrapper = styled.div`
  height: 2.2em;
  margin-bottom: 0.7em;

  display: flex;
  align-items: center;
`;

const CongratulationsTitle = styled.div`
  font-size: 1.4em;
  font-weight: bold;

  ${({ $skinId }) => {
    const textStyle = BoomUIBySkinId[$skinId]?.TEXT_STYLE;

    return css`
      color: ${textStyle?.color};
    `;
  }}
`;

type PropsType = {
  className?: string;
  steps: BoomStepState[];
  currenStepStatus: BoomStepStatus;
  isCompleted: boolean;
};

const BoomStepper = ({ className = '', steps, currenStepStatus, isCompleted }: PropsType) => {
  const { currentStepId, nbWonSteps } = useBoomHomeContext();
  const { skinId } = useBoomContext();

  return (
    <StyledBoomBoxWrapper className={className} isSuccess={isCompleted}>
      {isCompleted ? (
        <CongratulationsWrapper>
          <CongratulationsTitle $skinId={skinId}>{__('Congratulations on your journey!') + ' 👏'}</CongratulationsTitle>
        </CongratulationsWrapper>
      ) : (
        <StyledBoomDetailsInfoContainer nbWonSteps={nbWonSteps} stepId={currentStepId} stepStatus={currenStepStatus} />
      )}

      <StepList>
        {steps.map((step, index) => (
          <React.Fragment key={`boom-step-${index}`}>
            {index !== 0 ? (
              <SeparatorWrapper>
                <StyledSeparator stepDiff={index - nbWonSteps - 1} skinId={skinId} />
              </SeparatorWrapper>
            ) : null}
            <BoomStepItemContainer stepId={step.stepId} step={index + 1} />
          </React.Fragment>
        ))}
      </StepList>
    </StyledBoomBoxWrapper>
  );
};

export default BoomStepper;
